import ReviewsFilterInput from '@app/model/review/input/ReviewsFilterInput';
import ReviewsStateFilter from '@app/model/review/input/ReviewsStateFilter';

export const ReviewsQueryKeys = {
	all: ['reviews'] as const,
	categories: () => [...ReviewsQueryKeys.all, 'categories'] as const,
	filter: (filter: ReviewsFilterInput) => [...ReviewsQueryKeys.all, 'filter', filter] as const,
	categoryReviews: (companyHotelId: number, hotelId: number, categoryId: number) => [...ReviewsQueryKeys.all, 'categoryReviews', companyHotelId, hotelId, categoryId] as const,
	reviewsStateForPeriod: (companyHotelId: number, reviewsStateFilter: ReviewsStateFilter | undefined) => [...ReviewsQueryKeys.all, 'statistics', companyHotelId, reviewsStateFilter] as const,
	groupReviewsStateForPeriod: () => [...ReviewsQueryKeys.all, 'groupStatistics'] as const,
	weeklyDigest: (companyHotelId: number) => [...ReviewsQueryKeys.all, 'weeklyDigest', companyHotelId] as const,
	monthlyDigest: (companyHotelId: number) => [...ReviewsQueryKeys.all, 'monthlyDigest', companyHotelId] as const,
	insightsDeliverySchedules: (companyHotelId: number) => [...ReviewsQueryKeys.all, 'insightsDeliverySchedules', companyHotelId] as const,
};
